<template>
    <b-card @click.prevent="showPatient(data.id)" :class="{'d-flex flex-row':true}" no-body>
        <div class="pl-1 d-flex flex-grow-1 min-width-zero">
            <div class="card-body hovered cursor-pointer align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p class="list-item-heading mb-1 truncate"> <i class="simple-icon-user mr-1"></i> {{data.name}}</p>
                <p class="mb-1 text-muted w-15 w-sm-100">{{data.cin}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100">{{data.email}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100">{{data.phone}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100">{{data.mituel}}</p>
            </div>
            <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
                <b-button @click.stop="editItem()" class="mb-1 mr-1" variant="primary"><i class="iconsminds-pen"></i></b-button>
                <b-button @click.stop="deleteItem()" class="mb-1" variant="danger"><i class="simple-icon-trash"></i></b-button>
            </div> 
        </div>
    </b-card>
</template>
<script>
export default {
  props: ['data', 'selectedItems'],
  methods: {
    showPatient (itemId) {
      this.$router.push({name:"patient",params:{id:itemId}})
    },
    editItem(){
      this.$emit("edit",true)
    },
    deleteItem(){
      this.$emit("delete",true)
    }
  }
}
</script>
